import { MetricsKind } from "../types";
import { SIMPLE_SUM } from "./simple-sum";
import { ValueGetterParams } from "ag-grid-community";
import { DIMENSION_IDS_DELIMITER } from "epics/collections";

export const UNIT_DOOR_PERCENTAGE_PLAN = ({ factoryOptions, getterParams }) => {
    const unitsFactoryOptions = { ...factoryOptions, metric: { kind: MetricsKind.UNITS } };
    const unitsPlanRows = SIMPLE_SUM({ factoryOptions: unitsFactoryOptions, getterParams });
    const { filteredDeliveriesForAssortmentSet, filteredDoorsForAssortmentSet } = factoryOptions;

    const {
        data: { reviewPlan },
    }: ValueGetterParams = getterParams;

    let totalUnitsForPlanRow = 0;
    if (reviewPlan) {
        Object.keys(reviewPlan).forEach((key) => {
            const reviewPlanItem = reviewPlan[key].struct_value;
            const tokens = key.split(DIMENSION_IDS_DELIMITER);
            let doorKey;
            let deliveryKey;

            if (tokens.length === 3) {
                doorKey = tokens[0];
                deliveryKey = tokens[2];
            } else if (tokens.length > 0) {
                doorKey = tokens[0];
            }

            // Find metric for this item
            if (reviewPlanItem.metrics) {
                for (const metric of reviewPlanItem.metrics) {
                    const metricValue = metric.value?.number_value ?? 0;
                    if (
                        metric.kind === MetricsKind.UNITS &&
                        filteredDeliveriesForAssortmentSet.has(deliveryKey) &&
                        filteredDoorsForAssortmentSet.has(doorKey)
                    ) {
                        totalUnitsForPlanRow += metricValue;
                        break;
                    }
                }
            }
        });
    }

    if (unitsPlanRows > 0 && totalUnitsForPlanRow > 0) {
        return (unitsPlanRows / totalUnitsForPlanRow) * 100;
    }

    return 0;
};
